module.exports = __webpack_public_path__ + "assets/images/premium-locked-screen/shift-tasks/task-modal-with-shadow-e2f6ed.svg";